import React from 'react';
import { Box, Section } from '@common/components';
import { Row, Col, Typography } from 'antd';

const Prayer = ({ prayer, onClick }) => {
	return (
		<Box className="p-5">
			<Section className="mb-3" hoverable shadowed>
				<Row type="flex" className="login-links">
					<Col flex={1} onClick={() => onClick && onClick(prayer)}>
						<Typography.Text level={3}>
							{prayer.prayer}
						</Typography.Text>
					</Col>
				</Row>
			</Section>
		</Box>
	);
};

export default Prayer;
